export function uniqueId(prepend) {
	let addPrepend = (prepend !== undefined) ? prepend + '-' : '',
	compile = 'id-' + addPrepend + Math.random().toString(36).substr(2, 16);

	if(document.getElementById(compile) !== null){
		return uniqueId();
	}



	return compile;
}



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/classesAndIds.js